import React, { useContext, useEffect, useState } from "react";
import Application from "../../../StateContext/Application.js";
import {
  BudgetHeadCreationBlue32,
  Cancel32,
  DeleteRed32,
  EditBlueBlue32,
  submit,
  Tax32,
  UpdateWhite32,
  EditIcon,
  DeleteIcon,
  Edit32WHITE,
  Delete32WHITE,
  Excel32,
  JPG32,
  PNG32,
  PDF32,
  Approved32,
  SendBack32,
} from "../../../../../public/LoginImages/importimages";
import { apiurl } from "../../../../../path";
import CreateProject from "../CreateProject/CreateProject.js";
const ProjectInwardList = () => {
  const operation = useContext(Application);
  const { GetProjectList, ProjectApproval, Usermenu, GetProjectInfo } =
    operation;

  const [project, setProject] = useState([]);
  const [loading, setLoading] = useState(false);
  const [SelectedOptions, setSelectedOptions] = useState("Pending");
  const [selectedBills, setSelectedBills] = useState([]);
  const [filteredBills, setFilteredBills] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const billsPerPage = 10;
  const [searchTerm, setSearchTerm] = useState("");
  const [rejectPanelhide, setRejectpanelhide] = useState(1);
  const [remark, setRemark] = useState("");
  const [menuData, setMenuData] = useState({});
  const [EditProjectId, setEditProjectId] = useState(null);
  const [showEditForm, setShowEditForm] = useState(false);
  const [editProjectData, setEditProjectData] = useState(null);

  const totalPages = Math.ceil(filteredBills?.length / billsPerPage);
  const indexOfLastBill = currentPage * billsPerPage;
  const indexOfFirstBill = indexOfLastBill - billsPerPage;
  const currentBills = filteredBills?.slice(indexOfFirstBill, indexOfLastBill);
  console.log("currentbills", currentBills);
  console.log("Edit Project Data:", editProjectData);
  useEffect(() => {
    const getMenu = async () => {
      const res = await Usermenu();
      console.log(res);
      // setMenuData(res.Data);
      setMenuData(res?.Data || {});
    };

    getMenu();
  }, []);
  const isMaker =
    menuData?.Department_Name === "State Maker" &&
    menuData?.Role === "State Maker";

  const isChecker =
    menuData?.Department_Name === "State Checker" &&
    menuData?.Role === "State Checker";
  console.log("menuData", menuData);

  useEffect(() => {
    ProjectList();
  }, []);


  const ProjectList = async () => {
    try {
      let res = await GetProjectList();
      console.log("res", res);
      const result = res?.result || [];
      const sortedProjects = [...result].sort(
        (a, b) => new Date(b.Date) - new Date(a.Date),
      );
      setFilteredBills(sortedProjects);
      setProject(sortedProjects);
      setCurrentPage(1);
    } catch (err) {
      console.log(err);
    }
  };
// 05-10 for serch
useEffect(() => {
  const value = searchTerm.trim().toLowerCase();
 
  const filtered = project.filter((item) => {
    return (
      item.ProjectId?.toString().toLowerCase().includes(value) ||
      item.ProjectName?.toString().toLowerCase().includes(value) ||
      item.FinancialYear?.toString().toLowerCase().includes(value) ||
      item.Scheme?.toString().toLowerCase().includes(value) ||
      item.PIU?.toString().toLowerCase().includes(value)
    );
  });
 
  setFilteredBills(filtered);
  setCurrentPage(1);
}, [searchTerm, project]);
// ------------
  const handleCheckboxChange = (id) => {
    setSelectedBills((prevSelected) =>
      prevSelected.includes(id)
        ? prevSelected.filter((billId) => billId !== id)
        : [...prevSelected, id],
    );
  };

  console.log("Slected id form table :: ", selectedBills);
  console.log("Filtered data id form table :: ", filteredBills);

  const handleSelectAll = (event) => {
    const checked = event.target.checked;

    if (checked) {
      // Select all ProjectIds from the current page
      const currentPageIds = currentBills.map((project) => project.ProjectId);

      setSelectedBills((prevSelected) => [
        ...new Set([...prevSelected, ...currentPageIds]),
      ]);
    } else {
      // Remove only current page projects from selection
      const currentPageIds = currentBills.map((project) => project.ProjectId);

      setSelectedBills((prevSelected) =>
        prevSelected.filter((id) => !currentPageIds.includes(id)),
      );
    }
  };

  const approveorrejectSelected = async (condition) => {
    if (selectedBills.length === 0) {
      alert("No Project selected for approval!");
      return;
    }
    console.log(selectedBills);
    setLoading(true);
    let shouldStart = window.confirm("Are you sure ???");

    if (shouldStart) {
      try {
        let response = await ProjectApproval(selectedBills, condition, remark);
        if (response.message) {
          alert(response.message);
          setRejectpanelhide(0);
          setRemark("");
          setLoading(false);
          window.location.reload();
        }
        if (response.error) {
          alert(response.error);
          setRejectpanelhide(0);
          setRemark("");
          setLoading(false);
          window.location.reload();
        }
      } catch (error) {
        console.error("Error approving Proposal:", error);
        alert("An error occurred while approving bills.");
        setRejectpanelhide(0);
        setLoading(false);
        setRemark("");
        window.location.reload();
      }
    } else {
      alert(`Project ${condition} Operation Cancelled !!!`);
      setRemark("");
      setRejectpanelhide(0);
      window.location.reload();
    }
    setLoading(false); // Stop loader
  };

  const rejectSendbackbeforecheckup = (id) => {
    if (selectedBills.length > 0) {
      setRejectpanelhide(id);
    } else {
      alert("No Bill Selected !!!");
    }
  };
  //Edit Project Function
  const handleEditProject = async () => {
    if (selectedBills.length !== 1) {
      alert("Please select exactly one project to edit.");
      return;
    }
    try {
      const selectedProjectId = selectedBills[0];
      const res = await GetProjectInfo(selectedProjectId, "id");
      console.log("show result", res);

      setEditProjectData(res[0]);
      setShowEditForm(true); // Hide table and show form
    } catch (err) {
      console.log(err);
    }
  };

  const getPageNumbers = (currentPage, totalPages) => {
    const maxVisiblePages = 5;

    // 5 ya usse kam pages
    if (totalPages <= maxVisiblePages) {
      return Array.from({ length: totalPages }, (_, index) => index + 1);
    }

    // Starting pages
    // 1 2 3 4 5 ... Last
    if (currentPage <= 3) {
      return [1, 2, 3, 4, 5, "...", totalPages];
    }

    // Last pages
    // ... 16 17 18 19 20
    if (currentPage >= totalPages - 2) {
      return [
        "...",
        totalPages - 4,
        totalPages - 3,
        totalPages - 2,
        totalPages - 1,
        totalPages,
      ];
    }

    // Middle pages
    // ... 4 5 6 7 8 ... 20
    return [
      "...",
      currentPage - 2,
      currentPage - 1,
      currentPage,
      currentPage + 1,
      currentPage + 2,
      "...",
      totalPages,
    ];
  };

  return (
    <>
      {!showEditForm ? (
        <>
          <div
            className="project-page-wrapper"
            style={{
              width: "100%",

              height: "calc(100vh - 80px)",

              overflow: "hidden",

              boxSizing: "border-box",

              padding: "10px 15px 15px 15px",
            }}
          >
            <div
              className="project-content-wrapper"
              style={{
                width: "100%",
                height: "100%",

                minWidth: 0,
                minHeight: 0,

                boxSizing: "border-box",

                display: "flex",
                flexDirection: "column",
                alignItems: "center",

                overflow: "hidden",
              }}
            >
                {/* //29/10 */}
                <div
    style={{
      background: "#EEF2F7",
      border: "1px solid #dfe5ee",
      borderRadius: "10px",
      padding: "15px 20px 20px",
      width: "100%",
      maxHeight: "100%",
      overflowY: "auto",
      boxSizing: "border-box",
    }}
  >
              <div
                className="project-header"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",

                  width: "100%",
                  // maxWidth: "1000px",

                  padding: "0 5px",

                  marginTop: "8px",
                  marginBottom: "12px",

                  boxSizing: "border-box",

                  gap: "20px",

                  minWidth: 0,
                  flexShrink: 0,
                }}
              >
                <h5 className="my-auto fw-bold" style={{ fontSize: "18px" }}>
                  {/* <img src="/GR-Approval64.png" alt="Technical Approval" style={{ width: "24px", height: "24px" }} className='my-auto me-1' /> */}
                  <img
    src="/Project-Inward-List-32.png"
    alt="img" />
                  <span className="my-auto">Project Inward List</span>
                </h5>

                <div
                  style={{
                    position: "relative",

                    width: "300px",
                    // minWidth: "400px",
                    // maxWidth: "230px",

                    marginLeft: "auto",

                    boxSizing: "border-box",
                  }}
                >
                  <img
                    src="/Search32.png"
                    alt="Search Icon"
                    style={{
                      position: "absolute",
                      top: "50%",
                      left: "10px",
                      transform: "translateY(-50%)",
                      width: "16px",
                      height: "16px",
                      opacity: 0.6,
                    }}
                  />
                  <input
                    type="text"
                    placeholder="Search Here"
                    onChange={(e) => setSearchTerm(e.target.value)}
                    value={searchTerm}
                    style={{
                      width: "100%",
                      padding: "8px 12px 8px 32px", // left padding makes space for icon
                      border: "1px solid #ccc",
                      borderRadius: "8px",
                      // backgroundColor: "#f1f6fc",
                      fontSize: "14px",
                      color: "#333",
                      boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
                      outline: "none",
                    }}
                  />
                </div>
              </div>

              {loading && (
                <div
                  style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    background: "rgba(255, 255, 255, 0.7)",
                    backdropFilter: "blur(4px)",
                    zIndex: 9999,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{
                      border: "6px solid #f3f3f3",
                      borderTop: "6px solid #007bff",
                      borderRadius: "50%",
                      width: "60px",
                      height: "60px",
                      animation: "spin 1s linear infinite",
                    }}
                  />
                  <style>
                    {`@keyframes spin {0% { transform: rotate(0deg); }100% { transform: rotate(360deg); }}`}
                  </style>
                </div>
              )}

              <div
                className="project-white-card"
                style={{
                  backgroundColor: "#ffffff",
                  width: "100%",
                  //29/10
                  // maxWidth: "1300px",
                   padding: "15px 20px 5px",
                  margin: "0 auto",
                  borderRadius: "14px",
                  boxShadow: "0 3px 12px rgba(0, 0, 0, 0.15)",
                  boxSizing: "border-box",
                  minWidth: 0,
                  display: "flex",
                  flexDirection: "column",
                  overflow: "hidden",
                  flexShrink: 0,
                }}
              >
                <div
                  style={{
    width: "100%",
    minWidth: 0,
    overflowX: "auto",
    overflowY: "auto",
    border: "1px solid #d9e1f2",
    borderRadius: "10px",
    boxShadow: "0 2px 8px rgba(0,0,0,0.10)",
    boxSizing: "border-box",
    flex: "0 1 auto",      
    minHeight: 0,
    scrollbarWidth: "thin",
  }}
                >
                  {SelectedOptions === "Pending" && (
                    <table
                      style={{
    width: "100%",
    minWidth: "1200px",           
    borderCollapse: "separate",   
    borderSpacing: 0,
    whiteSpace:"nowrap"

  }}
                    >
                      <thead>
                        <tr
                          //28/10
                          style={{
                            backgroundColor: "#2D79D9",
                            color: "white",
                            height: "36px",
                            fontSize: "14px",
                            fontWeight: "600",
                          }}
                        >
                          <th
                            style={{
                              width: "90px",
                              minWidth: "50px",
                              padding: "8px",
                              textAlign: "center",
                            }}
                          >
                            <input
                              type="checkbox"
                              onChange={handleSelectAll}
                              // checked={
                              //   selectedBills.length === currentBills.length
                              // }
                              checked={
                                currentBills.length > 0 &&
                                currentBills.every((project) =>
                                  selectedBills.includes(project.ProjectId),
                                )
                              }
                              className="my-auto"
                              style={{ height: "18px", width: "18px" }}
                            />
                          </th>
                          <th style={{ width: "140px", padding: "8px" }}>
                            Sr.No
                          </th>
                          <th style={{ width: "140px", padding: "8px" }}>
                            Financial Year
                          </th>
                          <th style={{ width: "140px", padding: "8px" }}>
                            Scheme Type
                          </th>
                          <th style={{ width: "140px", padding: "8px" }}>
                            Project ID
                          </th>
                          <th style={{ width: "140px", padding: "8px" }}>
                            Project Name
                          </th>
                          <th style={{ width: "140px", padding: "8px" }}>
                            Project Details
                          </th>
                          {/* <th style={{ padding: "8px" }}>Object Code</th> */}
                          <th style={{ width: "140px", padding: "8px" }}>
                            Implementing Agency
                          </th>
                          <th style={{ width: "140px", padding: "8px" }}>
                            Project Cost
                          </th>
                          <th style={{ width: "140px", padding: "8px" }}>
                            Project Estimation Completion Date
                          </th>
                          <th style={{ width: "140px", padding: "8px" }}>
                            GRNumber
                          </th>
                          <th style={{ width: "140px", padding: "8px" }}>
                            GRDate
                          </th>
                          <th style={{ width: "140px", padding: "8px" }}>
                            GRCopy
                          </th>
                          <th style={{ width: "140px", padding: "8px" }}>
                            Creation Date
                          </th>
                          {isMaker && (
                            <th style={{ padding: "8px" }}>Remark</th>
                          )}
                          {isMaker && <th style={{ padding: 10 }}>Action</th>}
                        </tr>
                      </thead>
                      <tbody>
                        {currentBills.length <= 0 ? (
                          <tr>
                            {/* <td
                              colSpan="12"
                              style={{
                                textAlign: "center",
                                padding: "15px",
                                backgroundColor: "#ffffff",
                              }}
                            >
                              No data available
                            </td> */}
                          </tr>
                        ) : (
                          currentBills?.map((project, index) => {
                           const bgColor =
                              index % 2 === 0 ? "#E5F4FB" : "#CEE4F1";
                            return (
                              <tr
                                style={{
                                  backgroundColor: bgColor,
                                  fontSize: "13px",
                                  fontWeight: "500",
                                }}
                                key={index}
                              >
                                <td style={{ textAlign: "center" }}>
                                  <input
                                    type="checkbox"
                                    className="my-auto"
                                    style={{ height: "18px", width: "18px" }}
                                    checked={selectedBills.includes(
                                      project.ProjectId,
                                    )}
                                    onChange={() =>
                                      handleCheckboxChange(project.ProjectId)
                                    }
                                  />
                                </td>
                                <td
                                  style={{
                                    padding: "8px",
                                    textAlign: "center",
                                  }}
                                >
                                  {index + 1}
                                </td>
                                <td
                                  style={{
                                    padding: "8px",
                                    textAlign: "center",
                                  }}
                                >
                                  {project.FinancialYear}
                                </td>
                                <td
                                  style={{
                                    padding: "8px",
                                    textAlign: "center",
                                  }}
                                >
                                  {project.Scheme}
                                </td>
                                <td
                                  style={{
                                    color:"#5295c9",
                                    padding: "8px",
                                    textAlign: "center",
                                  }}
                                >
                                  {project.ProjectId}
                                </td>
                                <td
                                 
                                  // 05-10
                                  style={{
    padding: 10,
    whiteSpace: "normal",
    wordBreak: "break-word",
    overflowWrap: "break-word",
    maxWidth: "200px",
    lineHeight: "1.4",
  }}
                                >
                                  {project.ProjectName}
                                </td>
                                <td
                                  // 05-10
                                  style={{
    padding: 10,
    whiteSpace: "normal",
    wordBreak: "break-word",
    overflowWrap: "break-word",
    maxWidth: "200px",
    lineHeight: "1.4",
  }}
                                >
                                  {project.ProjectDetails}
                                </td>
                                {/* <td style={{ padding:  "8px" ,textAlign:"center"  }}>{project.ObjectCode}</td> */}
                                <td
                                  style={{
                                    padding: "8px",
                                    textAlign: "center",
                                  }}
                                >
                                  {project.PIU}
                                </td>
                                <td
                                  style={{
                                    padding: "8px",
                                    textAlign: "center",
                                  }}
                                >
                                  {" "}
                                  {Number(
                                    project.ProjectCost || 0,
                                  ).toLocaleString("en-IN")}
                                </td>
                                <td
                                  style={{
                                    padding: "8px",
                                    textAlign: "center",
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  <img
                                    src={"/Time-32.png"}
                                    style={{
                                      marginRight: "5px",
                                      width: "15px",
                                      height: "15px",
                                    }}
                                  />
                                  {project.ProjectEstCompletionDate?.split(
                                    "T",
                                  )[0].replace(" ")}
                                </td>
                                <td
                                  style={{
                                    // backgroundColor: "#e5ebfa",
                                    color: "#222",
                                    height: "36px",
                                    fontSize: "12px",
                                    fontWeight: "700",
                                  }}
                                >
                                  {project.GRNumber}
                                </td>
                                <td
                                  style={{
                                    padding: "8px",
                                    minWidth: "140px",
                                    width: "140px",
                                    whiteSpace: "nowrap",
                                    textAlign: "center",
                                  }}
                                >
                                  <img
                                    src={"/Time-32.png"}
                                    style={{
                                      marginRight: "5px",
                                      width: "15px",
                                      height: "15px",
                                    }}
                                  />
                                  {project.GRDate?.split("T")[0].replace(" ")}
                                </td>
                              
                                <td  style={{
                                                                    padding: "8px",
                                                                    minWidth: "160px",
                                                                    width: "160px",
                                                                    maxWidth: "160px",
                                                                    whiteSpace: "nowrap",
                                                                    textAlign: "center",
                                                                  }}>
                                                      {project.GRCopy ? (
                                                        (() => {
                                                          const ext = project.GRCopy.split(".")
                                                            .pop()
                                                            .toLowerCase();
                                                          let icon;
                                                          if (ext === "xls" || ext === "xlsx") {
                                                            icon = Excel32; // 🟢 Replace with your actual XLS icon import
                                                          } else if (ext === "jpg" || ext === "jpeg") {
                                                            icon = JPG32; // 🟢 Replace with your actual JPG icon import
                                                          } else if (ext === "png") {
                                                            icon = PNG32; // 🟢 Replace with your actual PNG icon import
                                                          } else if (ext === "pdf") {
                                                            icon = PDF32; // 🟢 Replace with your actual PNG icon import
                                                          } else {
                                                            icon = UpdateWhite32; // default icon (optional)
                                                          }
                                                   
                                                      return (
                                        <a
                                          href={`${apiurl}/ProjectDocsImages/${project.GRCopy}`}
                                          target="_blank"
                                          rel="noreferrer"
                                          title={project.GRCopy}   // 🔵 full filename shown on hover
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            gap: "5px",
                                            width: "100%",
                                            overflow: "hidden",
                                            textDecoration: "none",
                                            color: "#0d6efd",
                                          }}
                                        >
                                          <img
                                            src={icon}
                                            alt={ext + " icon"}
                                            style={{
                                              width: "20px",
                                              height: "20px",
                                              flexShrink: 0,
                                            }}
                                          />
                                          {project.ProjectId} GR Copy  {/* 🔵 CHANGED — fixed short label instead of project.GRCopy */}
                                        </a>
                                      );
                                    })()
                                  ) : (
                                    <span style={{ color: "#d9534f", fontWeight: 700 }}>No File</span>
                                  )}
                                                    </td>
                                <td
                                  style={{
                                    padding: "8px",
                                    minWidth: "140px",
                                    width: "140px",
                                    maxWidth: "140px",
                                    whiteSpace: "nowrap",
                                    textAlign: "center",
                                  }}
                                >
                                  {project.Date?.split("T")[0].replace(" ")}
                                </td>
                                {isMaker && (
                                  <td
                                    style={{
                                      padding: "8px",
                                      minWidth: "140px",
                                      width: "140px",
                                      maxWidth: "140px",
                                      whiteSpace: "nowrap",
                                      textAlign: "center",
                                    }}
                                  >
                                    {project.CheckerRemark}
                                  </td>
                                )}

                                {isMaker && (
                                  <div style={{marginLeft:"30px"}}>
                                  <td
                                    style={{
                                      // padding: "8px",
                                      minWidth: "140px",
                                      width: "140px",
                                      maxWidth: "140px",
                                      whiteSpace: "nowrap",
                                      textAlign: "center",
                                    }}
                                  >
                                    {/* Only Maker */}

                                     <button
 onClick={handleEditProject}
   disabled={selectedBills.length !== 1} style={{
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: "5px",
  marginLeft: "30px",
  padding: "8px 10px",
  fontWeight: "600",
  background:
    selectedBills.length !== 1
      ? "#6b6767"
      : "#0D6EFD",
 
  color:
    selectedBills.length !== 1
      ? "#888"
      : "white",
 
  border:
    selectedBills.length !== 1
      ? "1px solid #aaa1a1"
      : "1px solid #0D6EFD",
  borderRadius: "8px",
  cursor:
    selectedBills.length !== 1
      ? "not-allowed"
      : "pointer",
  opacity:
    selectedBills.length !== 1
      ? 0.65
      : 1,
  boxShadow:
    selectedBills.length !== 1
      ? "none"
      : "0 2px 4px rgba(0,0,0,0.15)",
}}
                                    >
                                      <img
                                        src={Edit32WHITE}
                                        style={{ width: "16px" }}
                                      />
                                  <span style={{color:"white", fontSize:"12px"}}>Edit</span>    
                                    </button>
 
                                  </td>
                                  </div>
                                )}
                              </tr>
                            );
                          })
                        )}
                      </tbody>
                    </table>


                  )}
                  

{/* // 24-09 no data foound msg */}
                    {(!Array.isArray(currentBills) || currentBills.length === 0) && (
                    <div
                      style={{
                        position: "sticky",
                        left: 0,
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "150px",
                        boxSizing: "border-box",
                        backgroundColor: "#ffffff",
                        color: "black",
                        fontSize: "15px",
                        fontWeight: 500,
                      }}
                    >
                      No data available
                    </div>
                  )}
                </div>

                <div className="col-12 mt-3">
                  <div className="row">
                    <div
                      className="col-6 text-start"
                      style={{ display: "flex", justifyContent: "left" }}
                    >
                      <button
                        onClick={() => approveorrejectSelected("Approved")}
                        disabled={selectedBills.length <= 0 ? true : loading}
                        className="ms-0"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "0.3rem",
                          margin: "12px",
                          padding: "8px 10px",
                          fontWeight: "600",
                          backgroundColor:
                            selectedBills.length <= 0 ? "#f3eeee" : "#39B54A",

                          color:
                            selectedBills.length > 0 ? "#ffffff" : "#01B574",
                          border: "1px solid #39B54A",
                          borderRadius: "8px",
                          cursor:
                            selectedBills.length <= 0
                              ? "not-allowed"
                              : loading
                                ? "not-allowed"
                                : "pointer",
                        }}
                      >
                        <img
                          src={Approved32}
                          alt="Approve"
                          style={{
                            width: "18px",
                            height: "18px",
                            flexShrink: 0,
                          }}
                        />
                        {loading ? "Processing..." : "Approve Selected"}
                      </button>

                      {isChecker && (
                        <button
                          onClick={() => rejectSendbackbeforecheckup(2)}
                          disabled={selectedBills.length <= 0 ? true : loading}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "0.3rem",
                            margin: "12px",
                            padding: "8px 10px",
                            fontWeight: "600",
                            backgroundColor:
                              selectedBills.length <= 0 ? "#f3eeee" : "#C1272D",

                            color: selectedBills.length > 0 ? "#ffffff" : "red",

                            border: "1px solid #ff6b81",
                            borderRadius: "8px",
                            cursor:
                              selectedBills.length <= 0
                                ? "not-allowed"
                                : loading
                                  ? "not-allowed"
                                  : "pointer",
                          }}
                        >
                          <img
                            src={DeleteRed32}
                            alt="Reject"
                            style={{
                              width: "18px",
                              height: "18px",
                              filter:
                                selectedBills.length > 0
                                  ? "brightness(0) invert(1)"
                                  : "none",
                            }}
                          />
                          {loading ? "Processing..." : "Reject Selected"}
                        </button>
                      )}
                      {isChecker && (
                        <button
                          onClick={() => rejectSendbackbeforecheckup(3)}
                          disabled={selectedBills.length <= 0 ? true : loading}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "3px",
                            margin: "12px",
                            padding: "8px 10px",
                            fontWeight: "600",
                            backgroundColor:
                              selectedBills.length <= 0 ? "#f3eeee" : "#0d6efd",

                            color:
                              selectedBills.length > 0 ? "#ffffff" : "#0d6efd",

                            border: "1px solid #0d6efd",
                            borderRadius: "8px",
                            cursor:
                              selectedBills.length <= 0
                                ? "not-allowed"
                                : loading
                                  ? "not-allowed"
                                  : "pointer",
                          }}
                        >
                          <img
                            src={SendBack32}
                            alt="Send Back"
                            style={{
                              width: "18px",
                              height: "18px",
                              flexShrink: 0,
                              filter:
                                selectedBills.length > 0
                                  ? "brightness(0) invert(1)"
                                  : "invert(28%) sepia(99%) saturate(7486%) hue-rotate(230deg) brightness(89%) contrast(128%)",
                            }}
                          />
                          {loading ? "Processing..." : "Send Back Selected"}
                        </button>
                      )}
                    </div>

                    <div
                      style={{
                        width: "100%",

                        display: "flex",

                        alignItems: "center",

                        justifyContent: "space-between",

                        marginTop: "10px",

                        padding: "0 20px",

                        boxSizing: "border-box",

                        flexShrink: 0,

                        overflow: "visible",
                        marginBottom: "20px",
                      }}
                    >
                      {/* ================= SHOWING ================= */}

                      <div
                        style={{
                          fontSize: "13px",

                          color: "#333",

                          whiteSpace: "nowrap",

                          paddingLeft: "5px",

                          flexShrink: 0,
                        }}
                      >
                        Showing{" "}
                        {filteredBills?.length === 0 ? 0 : indexOfFirstBill + 1}{" "}
                        to{" "}
                        {Math.min(indexOfLastBill, filteredBills?.length || 0)}{" "}
                        of {filteredBills?.length || 0} entries
                      </div>

                      {/* ================= PAGE NAVIGATION ================= */}

                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "18px",
                        }}
                      >
                        {/* ================= PREVIOUS ================= */}

                        <button
                          onClick={() =>
                            setCurrentPage((prev) => Math.max(prev - 1, 1))
                          }
                          disabled={currentPage === 1}
                          style={{
                            border: "none",
                            background: "transparent",

                            color: currentPage === 1 ? "#999" : "#2ea4e7",

                            cursor:
                              currentPage === 1 ? "not-allowed" : "pointer",

                            fontSize: "13px",

                            padding: 0,

                            display: "flex",
                            alignItems: "center",

                            gap: "4px",

                            opacity: currentPage === 1 ? 0.5 : 1,
                          }}
                        >
                          <span style={{ fontSize: "20px" }}>‹</span>
                          Previous
                        </button>

                        {/* ================= PAGE NUMBERS ================= */}

                        {getPageNumbers(currentPage, totalPages).map(
                          (pageNumber, index) => {
                            {
                              /* DOTS */
                            }

                            if (pageNumber === "...") {
                              return (
                                <span
                                  key={`ellipsis-${index}`}
                                  style={{
                                    fontSize: "13px",
                                    color: "#444",
                                  }}
                                >
                                  ...
                                </span>
                              );
                            }

                            {
                              /* PAGE BUTTON */
                            }

                            return (
                              <button
                                key={pageNumber}
                                onClick={() => setCurrentPage(pageNumber)}
                                style={{
                                  border: "none",

                                  background: "transparent",

                                  padding: 0,

                                  color:
                                    currentPage === pageNumber
                                      ? "#2ea4e7"
                                      : "#444",

                                  cursor: "pointer",

                                  fontSize: "13px",

                                  fontWeight:
                                    currentPage === pageNumber ? "600" : "400",

                                  textDecoration:
                                    currentPage === pageNumber
                                      ? "underline"
                                      : "none",
                                }}
                              >
                                {pageNumber}
                              </button>
                            );
                          },
                        )}

                        {/* ================= NEXT ================= */}

                        <button
                          onClick={() =>
                            setCurrentPage((prev) =>
                              Math.min(prev + 1, totalPages),
                            )
                          }
                          disabled={
                            currentPage === totalPages || totalPages === 0
                          }
                          style={{
                            border: "none",

                            background: "transparent",

                            color:
                              currentPage === totalPages || totalPages === 0
                                ? "#999"
                                : "#2ea4e7",

                            cursor:
                              currentPage === totalPages || totalPages === 0
                                ? "not-allowed"
                                : "pointer",

                            fontSize: "13px",

                            padding: 0,

                            display: "flex",
                            alignItems: "center",

                            gap: "4px",

                            opacity:
                              currentPage === totalPages || totalPages === 0
                                ? 0.5
                                : 1,
                          }}
                        >
                          Next
                          <span style={{ fontSize: "20px" }}>›</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          </div>

          {!showEditForm && rejectPanelhide === 2 && (
            <div
              className="col-12 RejectPanelContainer"
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                background: "rgba(0, 0, 0, 0.35)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 9999,
              }}
            >
              <div
                className="Rejectpanel"
                style={{
                  width: "500px",
                  background: "#fff",
                  borderRadius: "10px",
                  padding: "20px",
                  boxShadow: "0 0 15px rgba(0,0,0,0.2)",
                }}
              >
                <form action="">
                  <div className="col-12 elements">
                    <div className="row">
                      <div className="col-3">
                        <label className="fw-bold">
                          Remark <span className="text-danger">*</span>
                        </label>
                      </div>
                      <div className="col-8">
                        <textarea
                          name=""
                          id=""
                          placeholder="Enter Remark"
                          onChange={(e) => setRemark(e.target.value)}
                        ></textarea>
                      </div>
                    </div>
                  </div>
                </form>
                <div className="col-12 ms-auto my-4">
                  <div className="row">
                    {/* <div className="col-3"></div> */}
                    <div className="col-9 m-auto">
                      <div
                        className="col-12"
                        style={{
                          display: "flex",
                          gap: "10px",
                          justifyContent: "center",
                        }}
                      >
                        <button
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "4px",
                            background:
                              "linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5)",
                            width: "5rem",
                            height: "2rem",
                            fontSize: "18px",
                          }}
                          onClick={() => approveorrejectSelected("Rejected")}
                        >
                          <img src={submit} style={{ width: "15px" }} /> Reject
                        </button>
                        <button
                          type="button"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "4px",
                            backgroundColor: "#f1594c",
                            width: "6rem",
                            height: "2rem",
                            fontSize: "16px",
                          }}
                          onClick={() => window.location.reload()}
                        >
                          {" "}
                          <img src={Cancel32} style={{ width: "17px" }} />
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {!showEditForm && rejectPanelhide === 3 && (
            <div
              className="col-12 RejectPanelContainer"
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                background: "rgba(0, 0, 0, 0.35)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 9999,
              }}
            >
              <div
                className="Rejectpanel"
                style={{
                  width: "500px",
                  background: "#fff",
                  borderRadius: "10px",
                  padding: "20px",
                  boxShadow: "0 0 15px rgba(0,0,0,0.2)",
                }}
              >
                <form action="">
                  <div className="col-12 elements">
                    <div className="row">
                      <div className="col-3">
                        <label className="fw-bold">
                          Remark <span className="text-danger">*</span>
                        </label>
                      </div>
                      <div className="col-8">
                        <textarea
                          name=""
                          id=""
                          placeholder="Enter Remark"
                          onChange={(e) => setRemark(e.target.value)}
                        ></textarea>
                      </div>
                    </div>
                  </div>
                </form>
                <div className="col-12 ms-auto my-4">
                  <div className="row">
                    {/* <div className="col-3"></div> */}
                    <div className="col-9 m-auto">
                      <div
                        className="col-12"
                        style={{
                          display: "flex",
                          gap: "10px",
                          justifyContent: "center",
                        }}
                      >
                        <button
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "4px",
                            background:
                              "linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5)",
                            width: "8rem",
                            height: "2rem",
                            fontSize: "18px",
                          }}
                          onClick={() => approveorrejectSelected("SendBack")}
                        >
                          <img src={submit} style={{ width: "15px" }} /> Send
                          Back
                        </button>
                        <button
                          type="button"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "4px",
                            backgroundColor: "#f1594c",
                            width: "6rem",
                            height: "2rem",
                            fontSize: "16px",
                          }}
                          onClick={() => window.location.reload()}
                        >
                          {" "}
                          <img src={Cancel32} style={{ width: "17px" }} />
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </>
      ) : (
        <CreateProject
          isEdit={true}
          projectData={editProjectData}
          onSuccess={() => {
            setShowEditForm(false);
            ProjectList(); // Refresh table
            setSelectedBills([]);
          }}
          onCancel={() => {
            setShowEditForm(false);
          }}
        />
      )}
    </>
  );
};

export default ProjectInwardList;
